import React from 'react';
import generateComponentKeyString from './generateComponentKeyString';
import ScrollRenderer from '../Renderers/ScrollRenderer';

export default (
    cmWrapperComponent,
    cmContentMeta,
    index,
    cmComponents,
    propsData,
    limitInitialComponentsRendered = null
) => {
    const componentContent = cmContentMeta || {};
    const ComponentToRender = cmWrapperComponent.component;
    const rndKeyString = generateComponentKeyString(cmContentMeta.componentType, index);

    const { mapToProps } = cmWrapperComponent;
    const automationId = cmContentMeta.componentType;
    let mappedProps = {};
    const baseProps = {
        rndKeyString,
        ...propsData,
        automationId,
        cmComponentsWithoutGrid: cmComponents,
        componentType: cmContentMeta.componentType,
    };
    /* istanbul ignore else */
    if (mapToProps) {
        mappedProps = mapToProps(
            componentContent,
            baseProps.pageType,
            baseProps.deviceType,
            baseProps.preferences,
            baseProps.automationId,
            baseProps.featureFlags,
            baseProps.cmComponentsWithoutGrid,
            baseProps.componentType
        );
    } else {
        mappedProps = {
            ...cmContentMeta,
            ...baseProps,
        };
    }
    // TODO: action handling is pending
    return typeof limitInitialComponentsRendered === 'number' &&
        index >= limitInitialComponentsRendered ? (
        <ScrollRenderer offset={propsData.offset} height={propsData.height}>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <ComponentToRender key={rndKeyString} {...mappedProps} />
        </ScrollRenderer>
    ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ComponentToRender key={rndKeyString} {...mappedProps} />
    );
};
